// invoice cache singleton
import { remoteDBUrl } from '../helpers/config'
import {sortByField} from '../helpers/utils'

const invoicesByStop = {}

// reduce the long list of invoices for a stop by stopId {[stopId]: [...drafs]}
const sortByStopId = docs => {
  return docs.reduce((temp, doc) => {
    if (temp[doc.stopId]) {
      temp[doc.stopId].push(doc)
    } else {
      temp[doc.stopId] = [doc]
    }
    return temp
  }, {})
}

/**
 * Reconcile each delivery date (stopId) drafts to a single document for that delivery
 *
 * @param sortedDocs is {[stopId]: [..drafts]}
 * @return Array<ReconciledDoc>
 */
const reconcileByStopId = sortedDocs => {
  return Object.keys(sortedDocs)
    .map(stopId => sortByField(sortedDocs[stopId], 'createdAt'))
    .map(drafts => Object.assign({}, ...drafts))
}

export default {
  /**
   * Get invoices drafs for a stop name and reconcile each invoice for a delivery date
   * if it was in our cache leave else fetch and store for next retrieval
   * @param stopName
   * @returns Promise<Array>
   */
  getInvoicesByStop (stopName) {
    const invoices = invoicesByStop[stopName]
    if (invoices) {
      return Promise.resolve(invoices)
    }

    const fetchParams = {
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      method: 'POST',
      body: JSON.stringify({
        selector: {
          _id: {
            $regex: `invoice:[a-zA-Z0-9._%+-]{1,}:stop:${stopName}`
          }
        }
      })
    }

    // TODO: if any slowness in this approach, we switch to views/query
    const url = `${remoteDBUrl}/forth-payments/_find`

    return window.fetch(url, fetchParams)
      .then(res => res.json())
      .then(res => res.docs)
      .then(sortByStopId) // since a stop invoice can be delivered for several days of delivery
      .then(reconcileByStopId)
      .then(docs => {
        invoicesByStop[stopName] = docs
        return docs
      })
  }
}



// WEBPACK FOOTER //
// ./src/jobs/InvoiceCache.js